
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  email: string;
  userId: string;
  driverId: string;
  user_name: string;
  first_name: string;
  last_name: string;
  isAuthenticated: boolean;
  setEmail: (email: string) => void;
  setUserId: (userId: string) => void;
  setDriverId: (driverId: string) => void;
  setUserName: (user_name: string) => void;
  setFirstName: (first_name: string) => void;
  setLastName: (last_name: string) => void;
  loginAuth: () => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      email: "",
      userId: "",
      driverId: "",
      first_name: "",
      last_name: "",
      isAuthenticated: false,
      user_name: "",
      setEmail: (email) => set({ email }),
      setUserId: (userId) => set({ userId }),
      setDriverId: (driverId) => set({ driverId }),
      setFirstName: (first_name) => set({ first_name }),
      setLastName: (last_name) => set({ last_name }),
      setUserName: (user_name) => set({ user_name }),
      loginAuth: () => set({ isAuthenticated: true }),
      logout: () =>
        set({
          email: "",
          userId: "",
          driverId: "",
          first_name: "",
          last_name: "",
          user_name: "",
          isAuthenticated: false,
        }),
    }),
    {
      name: "auth-storage",
    }
  )
);
